import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Content from "../components/content";
import Loader from "../components/loader";
import { useImpersonation } from "../global/impersonation";

import { Box, Button, Menu, MenuItem, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import { DataGrid } from "@mui/x-data-grid";
import DownloadIcon from "@mui/icons-material/Download"

import ErrorModal from "../components/error_modal";
import BasicTitle from "../components/title";
import Api from "../libs/api";
import Helper from "../libs/helper";
import Storage from "../libs/storage";

const Holder = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: auto;
`;

const Title = styled.h3`
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 5px;
`;

const ModalRejector = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    height: 380px;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

const ModalPadding = styled.div`
    padding: 20px;
`;

const TextModalExport = styled.h3`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #181122;
    margin-bottom: 16px;
    text-align: center;
`;

const Data = styled.div`
    margin-bottom: 40px;
`;

export default function Impersonate() {
    let api = Api();
    let storage = Storage();
    let helper = Helper();
    let navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;
    const { startImpersonation } = useImpersonation();

    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState();
    const [rows, setRows] = useState([
        {
            id: 0,
            name: "---",
            user_name: "---",
            email: "---",
            last_login: "---",
        },
    ]);
    const [filter, setFilter] = useState("");
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState("");

    function showErrorModal(message) {
      setErrorModalMessage(message);
      setErrorModalOpen(true);
    }
    const columns = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "name", headerName: "CLIENTE", width: 200 },
        { field: "user_name", headerName: "RESPONSÁVEL", width: 200 },
        { field: "email", headerName: "CONTATO", width: 400 },
        { field: "last_login", headerName: "ÚLTIMO LOGIN", width: 200 },
        {
            field: "actions",
            headerName: "",
            sortable: false,
            disableExport: true,
            width: 150,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleImpersonate(params.row.id)}
                    style={{
                        borderRadius: 8,
                    }}
                >
                    IMPERSONAR
                </Button>
            ),
        },
    ];

    const handleImpersonate = (id) => {
        startImpersonation(id);
        navigate("/refunds");
    };

    const allCompanies = async () => {
        setLoading(true);
        try {
            const data = await storage.getItem("data");
            if (!data) return;
            let response = await api.allCompanies(data.token);
            response = response.data.allZagviewCompaniesWithOwners.edges;
            let _rows = [];
            for (let index = 0; index < response.length; index++) {
                const company = response[index].node;
                const _company = {
                    id: parseInt(atob(company?.id).split(":")[1]),
                    name: company?.name,
                    user_name: company?.ownerName,
                    email: company?.ownerEmail,
                    last_login: company?.ownerLastLogin ? helper.dateFromString(company?.ownerLastLogin) : "---",
                };

                let shouldPush = true;
                if (shouldPush) {
                    _rows.push(_company);
                }
            }
            setLoading(false);
            setRows(_rows);
            setCompanies(_rows);
        } catch (error) {
            setLoading(false);
            showErrorModal("Não foi possível aplicar os filtros. Verifique os dados e tente novamente.");
        }
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const handleFilter = () => {
        try {
            if (filter === "") {
                setRows(companies);
            } else {
                const filteredRows = companies.filter((company) =>
                    company.name.toLowerCase().includes(filter.toLowerCase())
                );
                setRows(filteredRows);
            }
        } catch (error) {
            showErrorModal("Não foi possível aplicar os filtros. Verifique os dados e tente novamente.");
        }
    };

    useEffect(() => {
        allCompanies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [openModalMessageExport, setOpenModalMessageExport] = useState(false);

    const closeModalMessageExport = () => {
        setOpenModalMessageExport(false);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleFilter();
        }
    };

    const generateCsv = async (showErrorModal) => {
        setLoading(true)
        try {

            const url = `${API_URL}/reports/impersonate/companies/csv`;

            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: { 
                    "Content-Type": "application/json",
                    Authorization: data.token,
                }
            };

            const response = await fetch(url, options);

            if (!response.ok) {

                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error("Erro ao gerar CSV. \nTente novamente mais tarde.");
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = 'zag_companies.csv';
            a.click();
            window.URL.revokeObjectURL(fileURL);
            setLoading(false)
        } catch (error) {
            setLoading(false)
            showErrorModal(error.message || "Não foi possível gerar o CSV. \nTente novamente mais tarde.");
        }
    };


    function CustomExportCompaniesMenu({ showErrorModal }) {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => setAnchorEl(event.currentTarget);
        const handleClose = () => setAnchorEl(null);

        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                    startIcon={<DownloadIcon />}
                    onClick={handleClick}
                    size="small"
                >
                    Exportar
                </Button>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                        onClick={() => {
                            generateCsv(showErrorModal);
                            handleClose();
                        }}
                    >
                        <DownloadIcon
                            fontSize="small"
                            style={{ marginRight: 8 }}
                        />
                        Exportar como CSV
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    return (
        <>
            {loading && <Loader />}

            <Holder>
                <Content title={"Impersonar"}>
                    <Box style={{ marginBottom: 20 }}>
                        <Title>INFORME A EMPRESA DESEJADA</Title>
                        <TextField
                            value={filter}
                            onChange={handleFilterChange}
                            onKeyDown={handleKeyDown}
                            variant="outlined"
                            style={{
                                width: 282,
                                height: 46,
                                borderRadius: 8,
                            }}
                        />
                        <Button
                            style={{
                                marginLeft: 16,
                                fontSize: 12,
                                padding: "10px 10px 10px 10px",
                                marginBottom: 30,
                                height: 57,
                                borderRadius: 8,
                                opacity: filter === "" ? 0.5 : 1,
                            }}
                            variant="contained"
                            disableelevation="true"
                            color="primary"
                            onClick={handleFilter}
                            disabled={filter === ""}
                        >
                            <img
                                src="/img/search.svg"
                                alt="Filtro"
                                style={{ width: 25, height: 25 }}
                            />
                        </Button>
                    </Box>
                    <Data style={{ marginBottom: 100 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            className={"hover"}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: 20 },
                                },
                            }}
                            // onCellClick={(
                            //   params: GridCellParams,
                            //   event: MuiEvent<React.MouseEvent>
                            // ) => {
                            //   event.defaultMuiPrevented = true;
                            // }}
                                                        slots={{
                                toolbar: () => (
                                    <CustomExportCompaniesMenu
                                        showErrorModal={showErrorModal}
                                    />
                                ),
                            }}
                            pageSizeOptions={[20, 50, 100]}
                            checkboxSelection
                            disableRowSelectionOnClick
                        />
                    </Data>
                </Content>
                <ErrorModal
                    open={errorModalOpen}
                    onClose={() => setErrorModalOpen(false)}
                    message={errorModalMessage}
                />
            </Holder>
            <Modal
                open={openModalMessageExport}
                onClose={closeModalMessageExport}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalRejector style={{ height: "auto" }}>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={closeModalMessageExport}
                    />
                    <ModalPadding>
                        <BasicTitle title={"EXPORTAR DADOS"} />
                    </ModalPadding>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                        }}
                    >
                        <TextModalExport>
                            AGUARDE ENQUANTO PREPARAMOS
                            <br /> SEU ARQUIVO.
                        </TextModalExport>
                        <img
                            src="/img/man.png"
                            alt=""
                            width={240}
                            height={240}
                        />
                        <TextModalExport
                            style={{
                                fontSize: 14,
                                marginTop: 24,
                                marginBottom: 40,
                                fontWeight: 400,
                            }}
                        >
                            Esta operação poderá levar alguns
                            <br /> minutos. Você receberá um e-mail
                            <br /> quando terminarmos de preparar tudo.
                        </TextModalExport>
                        <Button
                            style={{ marginBottom: 20 }}
                            variant="contained"
                            disableelevation="true"
                            color="primary"
                            onClick={closeModalMessageExport}
                        >
                            OK
                        </Button>
                    </div>
                </ModalRejector>
            </Modal>
        </>
    );
}